module.exports = __webpack_public_path__ + "static/media/TawtheeqTasjeel – Arabic@2x.f1ba7fcf.jpg";